/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";
// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAlert from "components/MDAlert";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";
import { useSearchParams, Link, useParams } from "react-router-dom";
import { UserAPI } from "api/UserAPI";

// Images
import bgImage from "assets/images/bg-reset-cover.jpeg";


function Cover() {

  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');

  let [searchParams] = useSearchParams();
  const params = useParams();

  const useVerify = () => {
    let id = params.id
    let hash = searchParams.get("hash");
    let expires = searchParams.get("expires");
    let signature = searchParams.get("signature");
    UserAPI.verify(id, hash, expires, signature)
      .then(response => {
        setAlertContent(response.message);
        setAlertColor('success');
      }).catch(error => {
        setAlertContent(error.response.data.message);
        setAlertColor('error');
      });
  }

  useEffect(() => {
    useVerify();
  }, []);

  return (
    <CoverLayout coverHeight="50vh" image={bgImage}>
      <Card >
        <MDBox
          variant="gradient"
          bgColor={alertColor}
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          py={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="body2" color="white" mt={1}>
            {alertContent}
          </MDTypography>
        </MDBox>
        <MDBox pb={3} px={3}>
          <MDBox mt={1} mb={1} textAlign="center">
            <MDTypography variant="button" color="info">
              <MDTypography
                component={Link}
                to="/authentication/sign-in"
                variant="button"
                fontWeight="medium"
                textGradient
              >
                Iniciar Sesión
              </MDTypography>
            </MDTypography>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout>
  );
}

export default Cover;